__webpack_require__.p = "https://live.asktek.net/ob_ai_enterprise_webapp/";